import { useSelector } from 'react-redux';

import { getLandingPageList } from '@/store/landingPageList/actions';

export const useInfinityScrollData = () => {
    const {
        loadingTemplates,
        loadingSubmitLandingPages,
        loadingAlreadySubscribedLandingPages,
        hasMoreTemplates,
        hasMoreSubmitPages,
        hasMoreAlreadySubscribedPages
    } = useSelector(getLandingPageList);

    const hasMore = {
        ActivationViaEmail: hasMoreTemplates,
        AlreadySubscribed: hasMoreAlreadySubscribedPages,
        FormSubmit: hasMoreSubmitPages
    }

    const loading = {
        ActivationViaEmail: loadingTemplates,
        AlreadySubscribed: loadingAlreadySubscribedLandingPages,
        FormSubmit: loadingSubmitLandingPages
    }

    return {loading, hasMore};
}